const actions = {
  GET_DATA_SHOPPINGS: 'GET_DATA_SHOPPINGS',
  GET_DATA_FINISH: 'GET_DATA_FINISH',
  GET_DATA_BEGIN: 'GET_DATA_BEGIN',
  SET_DATA_SHOPPINGS: 'SET_DATA_SHOPPINGS',
  SET_DATA_NEW_SHOPPING: 'SET_DATA_NEW_SHOPPING',
  getShoppingsData: () => {
    return {
      type: actions.GET_DATA_SHOPPINGS,
    };
  },
  getDataBegin: () => {
    return {
      type: actions.GET_DATA_BEGIN,
    };
  },
  getDataFinish: () => {
    return {
      type: actions.GET_DATA_FINISH,
    };
  },
  setShoppingsData: (data: any) => {
    return {
      type: actions.SET_DATA_SHOPPINGS,
      data,
    };
  },
  setNewShoppingData: (data: any) => {
    return {
      type: actions.SET_DATA_NEW_SHOPPING,
      data,
    };
  },
};

export default actions;
